<template>
  <div class="main">
      <ball></ball>
     <div class="nav">
         <Nav title="医院导航" :fixed='true'></Nav>
          <div class="top"></div>
     </div>
     <div class="img">
           <van-image
           :src="$global.account_url+url" 
           >
           </van-image>
     </div>
  </div>
</template>

<script>
import ball from "../../components/ball";
import Nav from "../../components/nav";
export default {
  components: {
    ball,
    Nav,
  },
   data(){
     return{
        url:"",
     }
 },
  mounted(){
      this.getbgimg()
  },
  methods:{
      async getbgimg(){
      //请求医院信息
      try {
        this.$showLoad()
        this.isLoad = true
        let url = '/register/Navigationimg'
       await this.$axios_request.request_data("nodeserver", url, "post", null,(data)=>{
        //医院名
        console.log(data)
        this.url=data.data
        this.$hideLoad()
       });
      } catch (error) {
        console.log(error)
        this.$hideLoad()
        this.$toast.fail('网络连接失败');
      }
    },
  }
};
</script>

<style lang="scss" scoped>
 .main{
     .nav{
         .top{
         height: 30px;
         width: 1px;
     }
     }
     .img{
         width: 95%;
         margin: 0px auto;
     }
 }
</style>